import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext.js';

const topics = [
  {
    title: 'Probability',
    description: 'A structured introduction to probability theory and its foundations.',
    to: '/resources/probability',
  },
];

const ResourcesPage = () => {
  const { isLight } = useTheme();

  return (
    <div className="min-h-screen pt-24 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 md:px-12">

        {/* Back Navigation */}
        <Link
          to="/"
          className={`inline-flex items-center gap-2 text-xs sm:text-sm font-mono uppercase tracking-widest transition-colors mb-8 sm:mb-12 ${
            isLight ? 'text-gray-400 hover:text-primary' : 'text-white/50 hover:text-accent'
          }`}
        >
          <span className="material-symbols-outlined text-sm">arrow_back</span>
          Back to Home
        </Link>

        {/* Page Header */}
        <div className="mb-12 sm:mb-16">
          <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <div className={`w-1.5 h-1.5 rounded-full ${
              isLight ? 'bg-primary shadow-[0_0_8px_#5e19e6]' : 'bg-accent shadow-[0_0_8px_#00f0ff]'
            }`} />
            <span className={`text-[9px] sm:text-[10px] font-mono uppercase tracking-widest ${
              isLight ? 'text-primary' : 'text-accent'
            }`}>
              Academy
            </span>
          </div>

          <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.1] mb-6 ${
            isLight ? 'text-gray-900' : 'text-white'
          }`}>
            Academy <br />
            <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r ${
              isLight ? 'from-gray-900 via-gray-500 to-gray-300' : 'from-white via-white/70 to-white/20'
            }`}>
              Resources.
            </span>
          </h1>

          <p className={`text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-[65ch] ${
            isLight ? 'text-gray-500' : 'text-white/60'
          }`}>
            Curated resources to support your learning journey.
          </p>
        </div>

        {/* Topic Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {topics.map((topic) => (
            <Link
              key={topic.to}
              to={topic.to}
              className={`group glass-panel rounded-xl p-6 sm:p-8 transition-all hover:scale-[1.02] ${
                isLight ? 'hover:shadow-lg hover:shadow-primary/5' : 'hover:border-accent/20'
              }`}
            >
              <div className="flex items-start justify-between mb-4">
                <h3 className={`text-lg sm:text-xl font-light ${
                  isLight ? 'text-gray-900' : 'text-white'
                }`}>
                  {topic.title}
                </h3>
                <span className={`material-symbols-outlined text-sm transition-transform group-hover:translate-x-1 ${
                  isLight ? 'text-primary' : 'text-accent'
                }`}>
                  arrow_forward
                </span>
              </div>
              <p className={`text-sm leading-relaxed ${
                isLight ? 'text-gray-500' : 'text-white/50'
              }`}>
                {topic.description}
              </p>
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ResourcesPage;
